import React, { useEffect } from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const ServiceProcessPage = () => {
    const { t } = useTranslation()

    const raw = t('serviceProcess.sections', { returnObjects: true })
    const sections = Array.isArray(raw) ? raw : []

    const scrollToSection = (e, id) => {
        e.preventDefault()
        const el = document.getElementById(id)
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        if (typeof window !== 'undefined' && window.history?.replaceState) {
            window.history.replaceState(null, '', `#${id}`)
        }
    }

    useEffect(() => {
        const hash = typeof window !== 'undefined' ? window.location.hash.replace(/^#/, '') : ''
        if (!hash) return
        const el = document.getElementById(hash)
        if (!el) return
        const t = window.setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 100)
        return () => window.clearTimeout(t)
    }, [])

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('header.service'), path: '/service' },
                { label: t('header.serviceProcess') }
            ]}
            title={t('serviceProcess.title')}
        >
            <div className="mb-10 max-w-4xl space-y-5">
                <nav aria-label={t('serviceProcess.jumpNavLabel')} className="text-xs sm:text-sm md:text-base leading-relaxed text-left">
                    <span className="flex flex-wrap gap-y-1">
                        {sections.map((section, i) => (
                            <React.Fragment key={section.id || i}>
                                {i > 0 && (
                                    <span className="mx-2 opacity-50">|</span>
                                )}
                                <a
                                    href={`#${section.id}`}
                                    onClick={(e) => scrollToSection(e, section.id)}
                                    className="text-primary hover:text-primary/80 underline underline-offset-4 transition-colors cursor-pointer"
                                >
                                    {section.title}
                                </a>
                            </React.Fragment>
                        ))}
                    </span>
                </nav>
                <p className="text-text-muted text-base leading-relaxed text-left whitespace-pre-line">{t('serviceProcess.subtitle')}</p>
            </div>

            <div className="space-y-14 md:space-y-20 max-w-4xl">
                {sections.map((section, i) => (
                    <motion.section
                        key={section.id || i}
                        id={section.id}
                        className="scroll-mt-32 md:scroll-mt-36"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: '-40px' }}
                        transition={{ duration: 0.45, delay: Math.min(i * 0.08, 0.24) }}
                    >
                        <div className="bio-card-static rounded-2xl border border-border-light overflow-hidden">
                            <div className="p-6 sm:p-8 border-b border-border-light/80 bg-surface-50/40">
                                <h2 className="text-xl sm:text-2xl font-display font-bold text-text-main mb-4">
                                    {section.title}
                                </h2>
                                <p className="text-sm sm:text-base text-text-muted leading-relaxed text-left whitespace-pre-line">
                                    {section.desc}
                                </p>
                            </div>
                            <div className="p-4 sm:p-6 bg-white">
                                <figure className="m-0">
                                    <img
                                        src={section.image}
                                        alt={section.imageAlt || ''}
                                        className="w-full h-auto rounded-xl border border-border-light/60 shadow-sm"
                                        loading={i === 0 ? 'eager' : 'lazy'}
                                    />
                                </figure>
                            </div>
                        </div>
                    </motion.section>
                ))}
            </div>

        </ServiceLayout>
    )
}

export default ServiceProcessPage
